(function () {
    'use strict';

    class BankAccountTypeSelectionController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, AnalyticsService) {
            super($scope, $injector);
            this.__objectType = 'BankAccountTypeSelectionController';
            this.AnalyticsService = AnalyticsService;
        }

        onAccountTypeClick(type) {
            this.AnalyticsService.trackClick(
                this, 
                'add bank account',
                { type }
            )
            this.onTypeSelection({type});
        }

        
    }

    Components.BankAccountTypeSelection = {
        bindings: {
            onTypeSelection: '&',
            customClass: '@?',
            shortText: '<?'
        },
        controller: BankAccountTypeSelectionController,
        name: 'hbBankAccountTypeSelection',
        templateUrl: 'angular/app/modules/core/features/settings/company/bank/bank_account_type_selection_component_template.html',
    };

}());